import { ContentBlock } from '../components'

const Shipped = () => <ContentBlock title="Your order is on it's way!" />

export default Shipped
